module.exports = "images/get-inspired-5.jpg";